module.exports = __webpack_public_path__ + "img/service.ffee84bb.png";